<template lang="html">
  <div>
    <vs-card v-if="!displayForm" class="cardx card-100-h">
      <div>
        <vs-row>
          <vs-col vs-lg="12" vs-sm="12" vs-xs="12" style="padding:10px">
            <div v-if="!item">
              <vs-table stripe search :data="groups">
                <template v-if="!partner_namespace" slot="header">
                  <vs-row style="margin-bottom:20px;">
                    <vs-col vs-lg="4" vs-sm="4" vs-xs="12">
                      <div style="margin-top: 10px;margin-bottom: 10px;">
                        <vs-button
                          @click="addGroup"
                          color="primary"
                          type="filled"
                          icon="add"
                          >Add new Group</vs-button
                        >
                      </div>
                    </vs-col>
                  </vs-row>
                </template>

                <template slot="thead">
                  <vs-th sort-key="name">
                    Name
                  </vs-th>
                  <vs-th sort-key="status">
                    Actions
                  </vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr :key="item.id" v-for="item in data">
                    <vs-td>
                      <p>{{ item.name }}</p>
                    </vs-td>
                    <vs-td style="width: 150px;">
                      <feather-icon
                        icon="EditIcon"
                        @click="editGroup(item)"
                        class="cursor-pointer navbar-fuzzy-search mr-4"
                      />
                      <feather-icon
                        icon="Trash2Icon"
                        @click="openConfirm(item)"
                        class="cursor-pointer navbar-fuzzy-search mr-4"
                      />
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
            <div v-else>
              <h3 style="margin-bottom: 10px;">{{ formTitle }}</h3>
              <div class="mb-4">
                <vs-input
                  class="inputx"
                  label="Name"
                  placeholder="Name"
                  v-model="item.name"
                  style="width:100%"
                />
              </div>
              <div class="mb-4">
                <label class="vs-input--label">Type</label>
                <v-select
                  v-model="item.type"
                  name="partner"
                  v-validate="'required'"
                  :class="errors.has('type') ? 'danger' : ''"
                  :options="types"
                  :reduce="el => el.value"
                  label="text"
                />
              </div>

              <div class="mb-4">
                <vs-checkbox v-model="item.is_active">Enable</vs-checkbox>
              </div>
              <div class="mb-4">
                <vs-button
                  class="mr-3"
                  @click="saveGroup"
                  color="danger"
                  type="filled"
                  >Guardar</vs-button
                >
                <vs-button @click="cancel" color="primary" type="filled"
                  >Cancelar</vs-button
                >
              </div>
            </div>
          </vs-col>
        </vs-row>
      </div>
    </vs-card>
    <vs-card
      class="cardx card-100-h"
      v-bind:style="{ height: windowHeight - 155 + 'px' }"
    >
      <div>
        <vs-row>
          <vs-col
            v-if="displayForm"
            vs-lg="12"
            vs-sm="6"
            vs-xs="12"
            style="padding:10px"
          >
            <h3 style="margin-bottom: 10px;">{{ formTitle }}</h3>

            <vs-row class="mb-4">
              <vs-col class="pr-2" vs-lg="6" vs-sm="6" vs-xs="12">
                <vs-input
                  class="inputx"
                  label="Name"
                  placeholder="Name"
                  v-model="item.name"
                  style="width:100%"
                  name="name"
                  v-validate="'required'"
                  :danger="errors.has('name')"
                  :danger-text="
                    errors.has('name') ? errors.first('name') : null
                  "
                />
              </vs-col>
              <vs-col class="pr-2" vs-lg="6" vs-sm="6" vs-xs="12">
                <vs-input
                  class="inputx"
                  label="Description"
                  placeholder="Description"
                  v-model="item.description"
                  style="width:100%"
                  name="description"
                  v-validate="'required'"
                  :danger="errors.has('description')"
                  :danger-text="
                    errors.has('description')
                      ? errors.first('description')
                      : null
                  "
                />
              </vs-col>
              <vs-col
                class="pr-2"
                vs-lg="6"
                vs-sm="6"
                vs-xs="12"
                v-if="formTitle != 'Edit'"
              >
                <label for="" class="vs-input--label">Zone:</label>
                <v-select
                  :clearable="false"
                  v-model="item.zone_id"
                  :options="zones"
                  :reduce="el => el.id"
                  label="name"
                  name="zone"
                  v-validate="'required'"
                  :class="errors.has('route.zone') ? 'danger' : ''"
                />
              </vs-col>
              <vs-col class="pr-2" vs-lg="6" vs-sm="6" vs-xs="11"> </vs-col>
            </vs-row>

            <vs-row class="mb-4 mt-2" v-if="formTitle === 'Edit'">   
              <vs-col vs-lg="12" vs-sm="12" vs-xs="12"  >
              <vs-table stripe>
                <template slot="thead">
                  <vs-th sort-key="name">
                    Route 
                  </vs-th>
                  <vs-th sort-key="type">
                    Type
                  </vs-th>
                  <vs-th sort-key="direction">
                    Direction
                  </vs-th>
                  <vs-th>
                    Actions
                  </vs-th>
                </template>
                <template >
                  <vs-tr :key="itemtable.route.id" v-for="itemtable in this.item.route_group">
                    <vs-td>
                      <p>{{ itemtable.route.name }}</p>
                    </vs-td>
                    <vs-td>
                      <p>{{ itemtable.type }}</p>
                    </vs-td>
                    <vs-td>
                      <p>{{ itemtable.route_direction }}</p>
                    </vs-td>
                    <vs-td>
                      <p>
                      <feather-icon
                        icon="Trash2Icon"
                        @click="openConfirm_route(itemtable.route.id)"
                        class="cursor-pointer navbar-fuzzy-search mr-4"
                      />
                      </p>
                    </vs-td>
                  </vs-tr>
                  </template>
                </vs-table>
                </vs-col>
                </vs-row>
            <div class="mb-4">
              <vs-button
                class="mr-3"
                @click="saveGroup"
                color="danger"
                type="filled"
                >Guardar</vs-button
              >
              <vs-button @click="cancel" color="primary" type="filled"
                >Cancelar</vs-button
              >
            </div>

            <vs-row class="mb-4 mt-2" v-if="formTitle === 'Edit'">   
              <vs-col vs-lg="4" vs-sm="4" vs-xs="12"  >
                <label for="" class="vs-input--label">Add Route:</label>
                <vs-select class="w-full" v-model="item.selected_route" >
                  <vs-select-item
                    :key="'lim-' + index"
                    :value="item_ind.id"
                    :text="item_ind.name"
                    v-for="(item_ind, index) in routes_perzone"
                  />
                </vs-select>
              </vs-col>   
              <vs-col class="pl-2"  vs-lg="4" vs-sm="4" vs-xs="12"  >

                <label for="" class="vs-input--label">Route Direction:</label>
<v-select :clearable="false" 
                          v-model="item.route_group_direction_type" :options="['IN', 'OUT', 'IN-OUT']"
                         label="type"
                          name="route_group_direction_type"
                /> 
              </vs-col> 
              <vs-col class="pl-2" vs-lg="4" vs-sm="4" vs-xs="12"  >

                <label for="" class="vs-input--label">Route Type:</label>
<v-select :clearable="false" 
                          v-model="item.route_group_type" :options="['FIXED', 'VARIABLE', 'SPECIAL']"
                         label="type"
                          name="route_group_type"
                /> 
              </vs-col>
            </vs-row>


            <div class="mb-4" v-if="formTitle === 'Edit'">
              <vs-button
                class="mr-3"
                @click="add_route"
                color="danger"
                type="filled"
                >Agregar Ruta</vs-button
              >
              <vs-button @click="cancel" color="primary" type="filled"
                >Cancelar</vs-button
              >
            </div>
          </vs-col>
        </vs-row>
      </div>
    </vs-card>
  </div>
</template>

<style scoped>
.card-100-h {
  height: calc(100% - 110px);
}
.mr-3 {
  margin-right: 3rem;
}
.mb-2 {
  margin-bottom: 2rem;
}
.mb-4 {
  margin-bottom: 4rem;
}
</style>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

const color = "rgb(115, 103, 240)";
export default {
  name: "ZoneList",
  data() {
    return {
      windowHeight: 0, 
      item: null,
      formTitle: "",
      drawingManager: null,
      selectedShape: null,
      routes_perzone: [],
      items: [],
      types: [
        { value: "PUBLIC", text: "Public" },
        { value: "PRIVATE", text: "Private" }
      ],
      displayForm: false
    };
  },
  computed: {
    ...mapGetters("users", ["userCan"]),
    ...mapState("zones", ["zones"]),
    ...mapState("groups", ["groups"]),
    ...mapState(["partner_namespace"])
  },
  created() {},
  watch: {
    windowHeight(newHeight, oldHeight) {
      this.txt = `it changed to ${newHeight} from ${oldHeight}`;
    }
  },
  mounted() {
    this.windowHeight = window.innerHeight;
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    ...mapActions("routes", ["fetchRoutes"]),
    ...mapActions("zones", [
      "fetchZones",
      "storeZone",
      "updateZone",
      "deleteZone"
    ]),
    ...mapActions("groups", [
      "fetchGroups",
      "storeGroup",
      "updateGroup",
      "deleteGroup",
      "getGroup",
      "getGroups",
      "assignRoute",
      "unassignRoute"
    ]),
    fetchData() {
      if (!this.userCan("routes.read")) {
        this.$vs.notify({
          color: "danger",
          title: `Error`,
          text: "You need permission to perform this action"
        });
        return;
      }

      this.fetchGroups({ limit: 10000 })
        .then(data => {})
        .catch(error => {});
    },
    fetchGroupeData(){
      let groupdataitem= {
        id:this.item.id
      }
      this.getGroup(groupdataitem) 
        .then(data => {
          this.item=data;
          this.fetchRoutesperZone();
        })
        .catch(error => {
          this.$vs.loading.close();
        });  
    },
    fetchRoutesperZone(){

      let filters_route = {
        limit: "1000",
        page: 1,
        zone_id: this.item.zone.id
      };
      this.fetchRoutes(_.cloneDeep(filters_route))
        .then(data => {
          this.routes_perzone = data.routes;
          this.displayForm = true;

          this.$vs.loading.close();
        })
        .catch(error => {
          this.$vs.loading.close();
        });
    },
    addGroup() {
      this.formTitle = "Add";
      this.item = { name: null };
      this.displayForm = true;
    },
    add_route() {
        this.$vs.loading({
          type: "point"
        });
       
        let item_route = {
          route_id: this.item.selected_route,
          service_group_id: this.item.id,
          type: this.item.route_group_type,
          route_direction: this.item.route_group_direction_type
        } 
        this.assignRoute(item_route)
          .then(data => {
            this.fetchGroupeData();
            this.$vs.loading.close();
          })
          .catch(error => {
            this.$vs.loading.close();
            if (error) {
              if (error.status === 409 || error.status === 400) {
                this.setErrors(error.data.errors);
              } else {
                this.$vs.notify({
                  color: "danger",
                  title: `Error`,
                  text: "There was an error. Please try again later."
                });
              }
            }
          });
    },
    async saveGroup() {
      let result = await this.$validator.validateAll();
      if (!result || this.onSubmit) {
        return;
      }
      if (this.onSubmit === true) return; 

      if (this.item.hasOwnProperty("id")) {
        if (!this.userCan("routes.update")) {
          this.$vs.notify({
            color: "danger",
            title: `Error`,
            text: "You need permission to perform this action"
          });
          return;
        }
        this.onSubmit = true;

        this.$vs.loading({
          type: "point"
        });

        this.item.zone_id = this.item.zone.id;
        delete this.item.route_group;
        delete this.item.zone;
        delete this.item.partner_account;

        delete this.routes_perzone;
        this.updateGroup(this.item)
          .then(data => {
            this.$vs.loading.close();
            this.onSubmit = false;
            this.fetchData();
            this.cancel();
            this.displayForm = false;
          })
          .catch(error => {
            this.$vs.loading.close();
            this.onSubmit = false;
            if (error) {
              if (error.status === 409 || error.status === 400) {
                this.setErrors(error.data.errors);
              } else {
                this.$vs.notify({
                  color: "danger",
                  title: `Error`,
                  text: "There was an error. Please try again later."
                });
              }
            }
          });
      } else {
        if (!this.userCan("routes.create")) {
          this.$vs.notify({
            color: "danger",
            title: `Error`,
            text: "You need permission to perform this action"
          });
          return;
        }
        this.onSubmit = true;

        this.$vs.loading({
          type: "point"
        });
        console.log('storegroup this item', this.item)
        this.item.partner_account_id= "d63a9c23-7bea-41a3-9bdc-5a1213dfecd7";
        this.storeGroup(this.item)
          .then(data => {
            this.$vs.loading.close();
            this.onSubmit = false;
            this.fetchData();
            this.cancel();
          })
          .catch(error => {
            this.$vs.loading.close();
            this.onSubmit = false;
            if (error) {
              if (error.status === 409 || error.status === 400) {
                this.setErrors(error.data.errors);
              } else {
                this.$vs.notify({
                  color: "danger",
                  title: `Error`,
                  text: "There was an error. Please try again later."
                });
              }
            }
          });
      }
    },
    editGroup(group) {
      this.$vs.loading({
        type: "point"
      });
      this.formTitle = "Edit";
      this.item = _.cloneDeep(group);

      this.fetchGroupeData()
    },
    openConfirm_route(route_id){
      if (!this.userCan("routes.delete")) {
        this.$vs.notify({
          color: "danger",
          title: `Error`,
          text: "You need permission to perform this action"
        });
        return;
      }
      let obj_unassign={
        route_id: route_id,
        id: this.item.id
      }
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text:
          "Are you sure yo want to delete this record?\n This cannot be undone!",
        accept: () => {
          this.unassignRoute(obj_unassign)
            .then(data => {
              this.fetchGroupeData(); 
            })
            .catch(error => {});
        }
      });

    },
    openConfirm(group) {
      if (!this.userCan("routes.delete")) {
        this.$vs.notify({
          color: "danger",
          title: `Error`,
          text: "You need permission to perform this action"
        });
        return;
      }

      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text:
          "Are you sure yo want to delete this record?\n This cannot be undone!",
        accept: () => {
          this.deleteGroup(group)
            .then(data => {
              this.fetchData();
            })
            .catch(error => {});
        }
      });
    },
    cancel() {
      this.item = null;
      this.displayForm = false;
    },
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    msgDialog(color, title, text, action) {
      this.$vs.dialog({
        color: color,
        title: title,
        text: text,
        accept: action
      });
    },
    setErrors(errors) {
      for (let key in errors) {
        if (Array.isArray(errors[key])) {
          this.errors.add({
            field: key,
            msg: errors[key][0]
          });
        }
      }
    }
  }
};
</script>
